<template>
  <v-app>
    <v-main v-if="!ready">
      <v-layout fill-height>
        <v-row fill-height align="center" justify="center">
          <v-progress-circular
            :size="$appLoading.size"
            :width="$appLoading.width"
            :color="$appLoading.color"
            indeterminate
          >{{ $appLoading.text }}</v-progress-circular>
        </v-row>
      </v-layout>
    </v-main>

    <template v-else>
      <v-main>
        <app-page :page="page" />
      </v-main>

      <m-pages-layout-footer />
    </template>
  </v-app>
</template>

<script>
import appPage from "./Page";
export default {
  components: {
    appPage,
  },

  data() {
    return {
      page: null,
      ready: false,
    };
  },

  async beforeMount() {
    const { data } = await this.$api.get(`/custom-page/${this.$currentPage}`);
    console.log("getPage", this.$currentPage, data);
    this.page = data.data;
    this.ready = true;
  },
};
</script>